jQuery(document).ready(function ($) {
	$(".RECIPE-PAGE__print-button").on("click", function () {
		window.print();
	});
});
